import React, { FunctionComponent } from 'react';
import { useRouter } from 'next/router';
import { useIntl } from 'react-intl';
import { Heading, Flex, Box } from 'mdlkit';
import Breadcrumb from './Breadcrumb';
import PersonIcon from './PersonIcon';
import ProfileIcon from './ProfileIcon';
import CoverageIcon from './CoverageIcon';

const CREATE_ACCOUNT_ROUTE = 'register';
const COMPLETE_PROFILE_ROUTE = 'profile';
const CHECK_COVERAGE_ROUTES = [
  'insurance',
  'eligibility-error',
  'register-review',
];

const findCoverageRoute = (pathname) =>
  CHECK_COVERAGE_ROUTES.find((route) => route === pathname) ||
  CHECK_COVERAGE_ROUTES[0];

const isStepComplete = (step, pathname) => {
  const ORDERED_ROUTES = [
    CREATE_ACCOUNT_ROUTE,
    COMPLETE_PROFILE_ROUTE,
    ...CHECK_COVERAGE_ROUTES,
  ];
  const stepIndex = ORDERED_ROUTES.findIndex((route) => step === route);
  const currentStepIndex = ORDERED_ROUTES.findIndex(
    (route) => pathname === route
  );

  return stepIndex < currentStepIndex;
};

interface Props {
  heading?: string;
}
const RegisterBreadcrumb: FunctionComponent<Props> = ({ heading }: Props) => {
  const router = useRouter();
  const { formatMessage: f } = useIntl();
  const currentPath = router.pathname.split('/').pop() || '';

  return (
    <Box width={1}>
      <Heading as="h1" align="center" pb="sm">
        {heading}
      </Heading>

      <Flex as="ul">
        <Breadcrumb
          id="createAccountCrumb"
          text={f({ id: 'register.createAccount' })}
          active={CREATE_ACCOUNT_ROUTE === currentPath}
          completed={isStepComplete(CREATE_ACCOUNT_ROUTE, currentPath)}
          icon={<PersonIcon />}
        />

        <Breadcrumb
          id="completeProfileCrumb"
          text={f({ id: 'register.completeProfile' })}
          m="auto"
          active={COMPLETE_PROFILE_ROUTE === currentPath}
          completed={isStepComplete(COMPLETE_PROFILE_ROUTE, currentPath)}
          icon={<ProfileIcon />}
        />

        <Breadcrumb
          id="checkCoverageCrumb"
          text={f({ id: 'register.checkCoverage' })}
          active={CHECK_COVERAGE_ROUTES.includes(currentPath)}
          completed={isStepComplete(
            findCoverageRoute(currentPath),
            currentPath
          )}
          icon={<CoverageIcon />}
        />
      </Flex>
    </Box>
  );
};

RegisterBreadcrumb.defaultProps = {
  heading: 'Welcome',
};
export default RegisterBreadcrumb;
